import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TrimAndUppercaseValueAccessorDirective } from './trimAndUppercase.directive';

@NgModule({
  declarations: [TrimAndUppercaseValueAccessorDirective],
  imports: [CommonModule],
  exports: [TrimAndUppercaseValueAccessorDirective],
})
export class TrimAndUppercaseModule {}
